import React, { useEffect, useState, useCallback, useRef } from 'react';
import Container from '../Container/Container';
import { useDispatch, useSelector } from 'react-redux';
import { get, post } from '../ApiServices/ApiServices';
import { useNavigate } from 'react-router';
import Loader from './Component/Loader';
import { useForm, Controller } from "react-hook-form";
import { toast } from 'react-toastify';
import moment from 'moment';
import Select from 'react-select';
import EmailEditor from './Wedding/EmailEditor';
import DeleteButton from './Component/DeleteFun';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

function Delinquent() {
	const navigate = useNavigate();
	const profile = useSelector((state) => state.profile.profile);
	const [delinquent, setDelinquent] = useState([]);
	const [loading, setLoading] = useState(false);
	const [apiLoading, setApiLoading] = useState(false);
	const [selectAll, setSelectAll] = useState(false);
	const [selectedCustomers, setSelectedCustomers] = useState([]);
	const [selectedCustomerslist, setSelectedCustomerslist] = useState([]);
	const [mergedIds, setMergedIds] = useState([]);
	const [isSubmittingone, setIsSubmittingone] = useState(false);

	useEffect(() => {
		console.log(...selectedCustomers, "selectedCustomersselectedCustomersselectedCustomers");

		setMergedIds([...selectedCustomers]);
	}, [selectedCustomers]);
	useEffect(() => {
		console.log(...selectedCustomerslist, "selectedCustomerslistselectedCustomerslistselectedCustomerslist");

		setMergedIds([...selectedCustomerslist]);
	}, [selectedCustomerslist]);

	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [searchTerm, setSearchTerm] = useState('');
	const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
	const [count, setCount] = useState(0);
	const [totalPages, setTotalPages] = useState(1);
	const [customer, setcustomer] = useState([])
	const [tickets, setTickets] = useState([]);
	const [orderInfo, setorderInfo] = useState(null)
	const [EmailNotice, setEmailNotice] = useState([]);
	const modalRef = useRef(null);
	const EmailmodalRef = useRef(null);
	const [selectedNotice, setSelectedNotice] = useState('1st');
	const [emailContent, setEmailContent] = useState('');
	const [subject, setSubject] = useState('');
	const [isLoading, setIsLoading] = useState(false);// Email templates with placeholders
	const [SingleDeliquent, SetSingleDeliquent] = useState("")
	const [loadingTickets, setLoadingTickets] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: null,
		endDate: null,
	});
	const [displayLabel, setDisplayLabel] = useState('');



	// Add these state variables
	// Add these state variables
	const [unreturnedOrders, setUnreturnedOrders] = useState([]);
	const [selectAllUnreturned, setSelectAllUnreturned] = useState(false);

	// Handler for unreturned checkboxes
	const handleUnreturnedSelect = (event, orderId) => {
		if (event.target.checked) {
			// Add to unreturned array
			setUnreturnedOrders(prev => [...prev, orderId]);
			console.log("Added to unreturned:", [...unreturnedOrders, orderId]);
		} else {
			// Remove from unreturned array
			setUnreturnedOrders(prev => prev.filter(id => id !== orderId));
			console.log("Removed from unreturned:", unreturnedOrders.filter(id => id !== orderId));
		}
	};

	// Handler for Select All Unreturned checkboxes
	const handleSelectAllUnreturned = (event) => {
		const isChecked = event.target.checked;
		setSelectAllUnreturned(isChecked);

		if (isChecked) {
			// Get all delinquent order IDs
			const allOrderIds = delinquent.map(order => order.delinquentOrderId);
			setUnreturnedOrders(allOrderIds);
			console.log("Selected all unreturned orders:", allOrderIds);
		} else {
			// Clear all selections
			setUnreturnedOrders([]);
			console.log("Cleared all unreturned orders");
		}
	};

	// Optional: Save unreturned orders to backend
	const saveUnreturnedOrders = async () => {
		console.log("Saving unreturned orders:", unreturnedOrders);
		// Add your API call here
		// Example:
		// try {
		//     const response = await axios.post('/api/save-unreturned', { 
		//         orderIds: unreturnedOrders 
		//     });
		//     console.log("Saved successfully:", response.data);
		// } catch (error) {
		//     console.error("Error saving unreturned orders:", error);
		// }
	};

	// Optional: Add useEffect to log unreturnedOrders when it changes
	useEffect(() => {
		console.log("Current unreturned orders:", unreturnedOrders);
	}, [unreturnedOrders]);





	const onDateChange = (dates) => {
		if (dates.startDate && dates.endDate) {
			setDateRange({
				startDate: dates.startDate,
				endDate: dates.endDate
			});
		} else {
			setDateRange({
				startDate: null,
				endDate: null
			});
		}
		setCurrentPage(1);
	};


	const handleApply = (event, picker) => {
		const startDate = picker.startDate;
		const endDate = picker.endDate;

		setDateRange({ startDate, endDate });
		setDisplayLabel(`${startDate.format('MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`);

		if (onDateChange) {
			onDateChange({
				startDate: startDate.format('YYYY-MM-DD'),
				endDate: endDate.format('YYYY-MM-DD')
			});
		}
	};

	const handleCancel = (event, picker) => {
		setDateRange({
			startDate: null,
			endDate: null,
		});
		setDisplayLabel('');
		setDateRange({
			startDate: null,
			endDate: null
		});

		// Reset the picker without destroying it
		if (picker) {
			picker.setStartDate(moment());
			picker.setEndDate(moment());
			picker.updateView();
		}
	};


	console.log(SingleDeliquent, "SingleDeliquent")
	const debounce = (func, delay) => {
		let timer;
		return function (...args) {
			clearTimeout(timer);
			timer = setTimeout(() => func.apply(this, args), delay);
		};
	};

	const handleSearchDebounced = useCallback(
		debounce((value) => {
			setDebouncedSearchTerm(value);
			setCurrentPage(1); // Reset to first page when searching
		}, 500),
		[]
	);

	const handleSearch = (e) => {
		const value = e.target.value;
		setSearchTerm(value);
		handleSearchDebounced(value);
	};

	// useEffect(() => {
	// 	alert(selectedCustomers, "first")
	// }, [selectedCustomers])

	// useEffect(() => {
	// 	alert(selectedCustomerslist, "second")
	// }, [selectedCustomerslist])



	const getDelinquent = async () => {
		setApiLoading(true);
		try {
			const api = `all-delinquent-orders?page_number=${currentPage}&sortby=createdAt&orderby=asc&size=${itemsPerPage}&search=${debouncedSearchTerm}&start_date=${dateRange?.startDate && moment(dateRange.startDate).isValid()
				? moment(dateRange.startDate).format('YYYY-MM-DD')
				: ""
				}&end_date=${dateRange?.endDate && moment(dateRange.endDate).isValid()
					? moment(dateRange.endDate).format('YYYY-MM-DD')
					: ""
				}`; const response = await get(api);

			if (response?.status === true) {
				setSelectedCustomers([])
				setSelectedCustomerslist([])
				setDelinquent(response.data?.rows || []);
				setCount(response?.data?.count || 0);
				setTotalPages(Math.ceil(response.data?.count / itemsPerPage));
			}
		} catch (err) {
			if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
				localStorage.removeItem('token');
				navigate('/login');
			}
			console.error("Error fetching delinquent orders:", err);
		} finally {
			setApiLoading(false);
		}
	};

	useEffect(() => {
		getDelinquent()
	}, [dateRange])
	const getCustomer = async () => {
		try {
			const api = `all-customers?size=${100}`;
			const response = await get(api);

			if (response?.status === true) {
				setcustomer(response?.data?.rows)
			}
		} catch (err) {
			if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
				localStorage.removeItem('token');
				navigate('/login');
			}
			console.error("Error fetching delinquent orders:", err);
		} finally {
		}
	};

	const getTemplate = async () => {
		try {
			const api = `notice-templates`;
			const response = await get(api);
			console.log(response, "response")
			if (response?.success === true) {
				setEmailNotice(response?.data)
			}
		} catch (err) {
			if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
				localStorage.removeItem('token');
				navigate('/login');
			}
			console.error("Error fetching delinquent orders:", err);
		} finally {
		}
	};

	useEffect(() => {
		getCustomer()
		getTemplate()
	}, [])


	useEffect(() => {
		setLoading(true);
		getDelinquent().finally(() => setLoading(false));
	}, [currentPage, itemsPerPage, debouncedSearchTerm]);

	const handlePageChange = (page) => {
		if (page >= 1 && page <= totalPages) {
			setCurrentPage(page);
		}
	};

	const handleItemsPerPageChange = (e) => {
		const newItemsPerPage = Number(e.target.value);
		setItemsPerPage(newItemsPerPage);
		setCurrentPage(1);
		setTotalPages(Math.ceil(count / newItemsPerPage));
	};

	const renderPaginationButtons = () => {
		const buttons = [];
		const maxVisibleButtons = 5;
		let startPage, endPage;

		if (totalPages <= maxVisibleButtons) {
			startPage = 1;
			endPage = totalPages;
		} else {
			const maxButtonsBeforeCurrent = Math.floor(maxVisibleButtons / 2);
			const maxButtonsAfterCurrent = Math.ceil(maxVisibleButtons / 2) - 1;

			if (currentPage <= maxButtonsBeforeCurrent) {
				startPage = 1;
				endPage = maxVisibleButtons;
			} else if (currentPage + maxButtonsAfterCurrent >= totalPages) {
				startPage = totalPages - maxVisibleButtons + 1;
				endPage = totalPages;
			} else {
				startPage = currentPage - maxButtonsBeforeCurrent;
				endPage = currentPage + maxButtonsAfterCurrent;
			}
		}

		for (let i = startPage; i <= endPage; i++) {
			buttons.push(
				<button
					key={i}
					className={`btn btn-sm ${currentPage === i ? 'btn-primary' : 'btn-outline-primary'}`}
					onClick={() => handlePageChange(i)}
					disabled={apiLoading}
				>
					{i}
				</button>
			);
		}
		return buttons;
	};


	const { register, handleSubmit, reset, setValue, control, watch, formState: { errors, isSubmitting, isValid } } = useForm();
	const secondForm = useForm();

	const customerName = watch("customerName");
	const ticket = watch("ticket");
	console.log(errors, "errorserrorserrorserrorserrorserrors")
	useEffect(() => {
		if (customerName && ticket) {
			const GetHelperApi = async () => {
				try {
					const api = `customer-order-info/${customerName}/${ticket}`;
					const response = await get(api);

					if (response?.status == true) {
						console.log(response, "responce0000000000")
						setorderInfo(response?.data)
					}
				} catch (err) {
					if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
						localStorage.removeItem('token');
						navigate('/login');
					}
					console.error("Error fetching delinquent orders:", err);
				} finally {
				}
			};
			GetHelperApi()
		}
	}, [customerName, ticket])

	useEffect(() => {
		let isMounted = true;
		const fetchTickets = async () => {
			if (!customerName) return;
			setLoadingTickets(true); // Start loader
			try {
				const api = `customer-orders/${encodeURIComponent(customerName)}`;
				const response = await get(api);
				if (isMounted && response?.status === true) {
					setTickets(response?.data?.rows || []);
				}
			} catch (err) {
				if (isMounted) {
					if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
						localStorage.removeItem('token');
						navigate('/login');
					} else {
						console.error("Error fetching tickets:", err);
					}
				}
			} finally {
				if (isMounted) setLoadingTickets(false); // Stop loader
			}
		};

		const debounceTimer = setTimeout(fetchTickets, 300);
		return () => {
			isMounted = false;
			clearTimeout(debounceTimer);
		};
	}, [customerName, navigate]);





	function calculateOrderLateBy(orderDate) {
		// If no order date is provided, return an empty string or appropriate message
		if (!orderDate) {
			return "Date not available";
		}

		// Parse the order date
		const eventDate = new Date(orderDate);
		console.log(eventDate, "eventDate")
		// Get current date
		const currentDate = new Date();
		console.log(currentDate, "currentDate")
		// Get the day of the week for the event date (0 = Sunday, 6 = Saturday)
		const eventDay = eventDate.getDay();

		// If order event date is between Sunday and Friday
		if (eventDay >= 0 && eventDay <= 5) {
			// Find the Friday of the next week after the event date
			const fridayOfNextWeek = new Date(eventDate);
			// Add days to get to next Friday (add 7 days to get to next week, then adjust to Friday)
			const daysToAdd = 7 - eventDay + 5;
			fridayOfNextWeek.setDate(eventDate.getDate() + daysToAdd);

			// Check if current date is past the Friday of next week
			if (currentDate > fridayOfNextWeek) {
				// Calculate weeks late
				const timeDiff = currentDate - fridayOfNextWeek;
				const weeksDiff = Math.floor(timeDiff / (7 * 24 * 60 * 60 * 1000));
				return `${weeksDiff + 1} week${weeksDiff > 0 ? 's' : ''} late`;
			} else {
				// Not late yet
				return "Not late";
			}
		} else {
			// If the event date is on Saturday, we need a different handling
			// For this example, treating Saturday same as Friday
			const fridayOfNextWeek = new Date(eventDate);
			fridayOfNextWeek.setDate(eventDate.getDate() + 6);

			if (currentDate > fridayOfNextWeek) {
				const timeDiff = currentDate - fridayOfNextWeek;
				const weeksDiff = Math.floor(timeDiff / (7 * 24 * 60 * 60 * 1000));
				return `${weeksDiff + 1} week${weeksDiff > 0 ? 's' : ''} late`;
			} else {
				return "Not late";
			}
		}
	}


	const onSubmit = async (data) => {
		setIsSubmittingone(true)
		try {
			const endpoint = `create-delinquent-order`;
			const date = orderInfo?.wedding?.wedding_date || orderInfo?.event_date;
			console.log(date, "datedatedatedatedate----------");

			// Calculate how late the order is
			const orderLateBy = calculateOrderLateBy(date);

			const payload = {
				customer_id: data?.customerName,
				ticket: data?.ticket,
				account_name: data?.account,
				order_late_by: orderLateBy,
				single_order_id: orderInfo?.wedding_id ? null : orderInfo?.id,
				wedding_id: orderInfo?.wedding_id || null
			};
			const response = await post(endpoint, payload);

			if (response.status) {
				toast.success(response?.message, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					closeButton: false,
				});
				getDelinquent()
				modalRef.current.click();
				reset();
				setIsSubmittingone(false)
			}
		} catch (err) {
			toast.error(err?.message, {
				position: "top-right",
				autoClose: 2000,
				hideProgressBar: false,
				closeOnClick: false,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				closeButton: false,
			});
			setIsSubmittingone(false)

		}
	};


	const watchedNoticeType = secondForm.watch('noticeType');

	// Handle sending email




	// Set default notice on component mount
	useEffect(() => {
		if (EmailNotice.length > 0) {
			setSelectedNotice(EmailNotice[0].noticeType);
			setSubject(EmailNotice[0].subject);
			setEmailContent(EmailNotice[0].body);
		}
	}, []);


	const selectedNoticeType = watch('noticeType');


	useEffect(() => {
		if (watchedNoticeType === "") {
			// Clear fields when "Please select notice type" is selected
			secondForm.setValue('subject', '');
			secondForm.setValue('emailContent', '');
		} else if (watchedNoticeType) {
			const selectedNotice = EmailNotice.find(notice => notice.noticeType === watchedNoticeType);
			if (selectedNotice) {
				secondForm.setValue('subject', selectedNotice.subject);
				secondForm.setValue('emailContent', selectedNotice.body);
			}
		}
	}, [watchedNoticeType, secondForm]);


	const handleSelectAll = (e) => {
		const isChecked = e.target.checked;
		setSelectAll(isChecked);

		if (isChecked) {
			// Select all order IDs from the current page's delinquent data
			const allOrderIds = delinquent.map(order => order.delinquentOrderId);
			setSelectedCustomers(allOrderIds);
		} else {
			setSelectedCustomers([]);
		}
	};

	// Update the handleCustomerSelect function
	const handleCustomerSelect = (e, orderId) => {
		const isChecked = e.target.checked;
		setSelectedCustomers(prev => {
			if (isChecked) {
				return [...prev, orderId];
			} else {
				return prev.filter(id => id !== orderId);
			}
		});

		// Update selectAll checkbox if needed
		if (!isChecked && selectAll) {
			setSelectAll(false);
		}
	};

	// Add useEffect to update selectAll state when selectedCustomers changes
	useEffect(() => {
		if (delinquent.length > 0 && selectedCustomers.length === delinquent.length) {
			setSelectAll(true);
		} else {
			setSelectAll(false);
		}
	}, [selectedCustomers, delinquent]);

	const checkAllAccountsSame = () => {
		if (delinquent.length === 0) return false;

		const firstAccount = delinquent[0]?.customer?.account;
		return delinquent.every(order => order?.customer?.account === firstAccount);
	};

	const showCheckboxes = checkAllAccountsSame();


	return (
		<Container>
			<div className="nk-content">
				<div className="container-fluid">
					<div className="nk-content-inner">
						<div className="nk-content-body">
							<div className="nk-block-head nk-block-head-sm">
								<div className="nk-block-between">
									<div className="nk-block-head-content">
										<h3 className="nk-block-title page-title">Delinquent Orders</h3>
									</div>
									{
										profile?.name == "Admin" &&
										<div className="nk-block-head-content">
											<div className="toggle-wrap nk-block-tools-toggle">
												<div className="toggle-expand-content" data-content="pageMenu">
													<ul className="nk-block-tools g-3">
														<li className="nk-block-tools-opt">
															<button
																className="btn btn-primary"
																data-bs-toggle="modal"
																data-bs-target="#addDelinquentModal"
																disabled={loading}
															>
																<span>Add Order</span>


															</button>
														</li>
													</ul>
												</div>
											</div>
										</div>
									}
								</div>
							</div>

							<div className="card card-full">
								<div className="card-inner">
									<div className="card-title-group mb-3">
										<div className="card-tools">
											<div className="form-control-wrap">
												<div className="form-icon form-icon-right">
													<em className="icon ni ni-search"></em>
												</div>
												<input
													type="text"
													className="form-control"
													placeholder="Search by ticket number or customer name"
													value={searchTerm}
													onChange={handleSearch}
													disabled={loading}
												/>
											</div>
											<div className="card-tools" style={{ flex: '1 0 -1px', paddingLeft: '15px' }} >
												<div className="form-control-wrap">
													<DateRangePicker
														initialSettings={{
															startDate: dateRange.startDate || moment(),
															endDate: dateRange.endDate || moment(),
															locale: {
																format: 'MMM D, YYYY',
																cancelLabel: 'Clear',
																applyLabel: 'Apply',
															},
															ranges: {
																'Today': [moment(), moment()],
																'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
																'Last 7 Days': [moment().subtract(6, 'days'), moment()],
																'Last 30 Days': [moment().subtract(29, 'days'), moment()],
																'This Month': [moment().startOf('month'), moment().endOf('month')],
																'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
															},
															opens: 'right',
															autoApply: true,
															autoUpdateInput: true,
															alwaysShowCalendars: true,
															showCustomRangeLabel: true,
															showCancel: true,
														}}
														onApply={handleApply}
														onCancel={handleCancel}
													>
														<input
															type="text"
															className="form-control"
															placeholder="Select date range"
															value={displayLabel}
															readOnly
															style={{
																cursor: 'pointer',
																backgroundColor: '#fff',
																border: '1px solid #dbdfea',
																borderRadius: '4px',
																padding: '0.375rem 0.75rem',
																minWidth: '142%',
																paddingRight: '30px',
																color: '#35495e',
															}}
														/>
													</DateRangePicker>
													{displayLabel && (
														<span
															className="clear-icon"
															onClick={(e) => {
																e.stopPropagation();
																e.preventDefault();
																// Find and trigger the cancel button click
																const cancelBtn = document.querySelector('.daterangepicker .cancelBtn');
																if (cancelBtn) {
																	cancelBtn.click();
																} else {
																	handleCancel();
																}
															}}
															style={{
																position: 'absolute',
																right: '-53px',
																top: '54%',
																transform: 'translateY(-50%)',
																cursor: 'pointer',
																zIndex: 10
															}}
														>
															<em className="icon ni ni-cross"></em>
														</span>
													)}
												</div>
											</div>
										</div>
									</div>

									{loading ? (
										<Loader />
									) : apiLoading ? (
										<Loader />
									) : (
										<>
											<div className="table-responsive">
												<table className="table table-striped">
													<thead>
														<tr>
															<th scope="col">Customer Name</th>
															<th scope="col">Event Date</th>
															<th scope="col">Ticket</th>
															{profile?.name === "Admin" && <th scope="col">Account</th>}
															{profile?.name === "Admin" && <th scope="col">Order Type</th>}
															{profile?.name === "Admin" && <th scope="col">Account Name</th>}
															<th scope="col">Weekending date</th>
															<th scope="col">Return Weeks</th>
															<th scope="col">Email Sent</th>
															{profile?.name === "Admissddn" && (
																<th scope="col" className="tableMinWidth150">
																	<div className="custom-control custom-control-sm custom-checkbox d-flex align-items-center gap-2">
																		<input
																			type="checkbox"
																			className="custom-control-input"
																			id="selectAllUnreturned"
																			checked={selectAllUnreturned}
																			onChange={(e) => handleSelectAllUnreturned(e)}
																		/>
																		<label className="custom-control-label mb-0" htmlFor="selectAllUnreturned">
																			Unreturned
																		</label>
																	</div>
																</th>
															)}
															{profile?.name === "Admin" && <th scope="col">Action</th>}
															{showCheckboxes && profile?.name == "Admin" && (
																<th scope="col" className="tableMinWidth150">
																	<div className="custom-control custom-control-sm custom-checkbox">
																		<input
																			type="checkbox"
																			className="custom-control-input"
																			id="customCheck7"
																			checked={selectAll}
																			onChange={(e) => {
																				handleSelectAll(e);
																				// When selecting all, set the first order as the single delinquent
																				if (e.target.checked && delinquent.length > 0) {
																					// Sort the delinquent array the same way it's sorted in the table
																					const sortedDelinquent = [...delinquent].sort((a, b) => {
																						const getDate = (order) => {
																							const dateStr = order.event_date || order.wedding_date;
																							if (!dateStr) return new Date(8640000000000000);
																							const date = new Date(dateStr);
																							return isNaN(date.getTime()) ? new Date(8640000000000000) : date;
																						};
																						return getDate(a) - getDate(b);
																					});
																					SetSingleDeliquent(sortedDelinquent[0]);
																				}
																			}}
																		/>
																		<label className="custom-control-label sendMailIcon" htmlFor="customCheck7">
																			<button
																				className="deleteTrash"
																				{...(selectedCustomers.length != 0 ? {
																					"data-bs-toggle": "modal",
																					"data-bs-target": "#emailNewTemplate"
																				} : {})}
																				onClick={(e) => {
																					if (selectedCustomers.length == 0) {
																						e.preventDefault();
																						alert("Please select at least one order to send email");
																					} else {
																						// Log the selected IDs array to console
																						console.log("Selected Orders IDs:", selectedCustomers);
																						console.log("Selected Orders Details:", selectedCustomerslist);
																					}
																				}}
																			>
																				<em className="icon ni ni-mail"></em> <small>Send Mail</small>
																			</button>
																		</label>
																	</div>
																</th>
															)}
														</tr>
													</thead>
													<tbody>
														{delinquent.length > 0 ? (
															[...delinquent]
																.sort((a, b) => {
																	// Helper function to get valid date
																	const getDate = (order) => {
																		const dateStr = order.event_date || order.wedding_date;
																		if (!dateStr) return new Date(8640000000000000); // Far future date if missing
																		const date = new Date(dateStr);
																		return isNaN(date.getTime()) ? new Date(8640000000000000) : date;
																	};

																	const dateA = getDate(a);
																	const dateB = getDate(b);

																	return dateA - dateB; // Ascending order (oldest first)
																})
																.map((order) => (
																	<tr key={order.delinquentOrderId}>
																		<td className="tableMinWidth120">{order?.first_name} {order?.last_name}</td>
																		<td className="tableMinWidth120">
																			{moment.utc(order?.event_date || order?.wedding_date).isValid()
																				? moment.utc(order?.event_date || order?.wedding_date).format("MMM D, YYYY")
																				: "N/A"}
																		</td>
																		<th
																			className="tableMinWidth120"
																			scope="row"
																			style={{ cursor: "pointer" }}
																			onClick={() => {
																				navigate(
																					order?.type == "single_order" ? "/order-detail" : "/Member-detail",
																					{
																						state: order?.type == "single_order"
																							? { orderId: order?.id }
																							: { eventId: order?.id }
																					}
																				)
																			}}
																		>
																			{order?.ticket}
																		</th>
																		{profile?.name === "Admin" && <td className="tableMinWidth120">{order?.customer?.account ? order?.customer?.account : "N/A"}</td>}
																		{profile?.name === "Admin" &&
																			<td className="tableMinWidth120">{order?.type == "single_order" ? "Single Order" : "Wedding Order"}</td>}
																		{profile?.name === "Admin" && <td className="tableMinWidth120">{order?.customer?.companyName ? order?.customer?.companyName : "N/A"}</td>}
																		<td className="tableMinWidth120">
																			{order?.type == "single_order" ? order?.weekend_date ? moment.utc(order?.weekend_date).format("MMM D, YYYY")
																				: "N/A" : order?.wedding?.weekend_date ? moment.utc(order?.wedding?.weekend_date).format("MMM D, YYYY") : "N/A"}

																		</td>
																		<td className="tableMinWidth120">{order?.order_late_by || "N/A"}</td>
																		<td className="tableMinWidth120">{order?.email_sent_on ? order?.email_sent_on : "N/A"}</td>
																		{/* Unreturned Checkbox Column */}
																		{profile?.name === "Admisfdsn" && (
																			<td className="tableMinWidth120">
																				<div className="custom-control custom-control-sm custom-checkbox">
																					<input
																						type="checkbox"
																						className="custom-control-input"
																						id={`unreturnedCheck${order.delinquentOrderId}`}
																						checked={unreturnedOrders?.includes(order.delinquentOrderId) || false}
																						onChange={(e) => {
																							handleUnreturnedSelect(e, order.delinquentOrderId);
																							// Log the unreturned array when checkbox is toggled
																							console.log("Unreturned Orders:", unreturnedOrders);
																						}}
																					/>
																					<label className="custom-control-label" htmlFor={`unreturnedCheck${order.delinquentOrderId}`}></label>
																				</div>
																			</td>
																		)}

																		{profile?.name === "Admin" && (
																			<>
																				<td>
																					<div className="tableActionBtn-1 flex" style={{ cursor: "pointer", gap: "3px" }}>
																						<button
																							className="deleteTrash"
																							onClick={() => {
																								navigate(
																									order?.type == "single_order" ? "/order-detail" : "/Member-detail",
																									{
																										state: order?.type === "single_order"
																											? { orderId: order?.id }
																											: { eventId: order?.id }
																									}
																								)
																							}}
																						>
																							<em className="icon ni ni-eye"></em>
																						</button>
																						<DeleteButton
																							url={`delete-delinquent-order/${order?.delinquentOrderId}`}
																							onDeleteSuccess={getDelinquent}
																						/>
																						{
																							<button
																								className={`deleteTrash ${(selectedCustomers.length != 0) ? 'disabled' : ''}`}
																								{...(selectedCustomers.length == 0 ? {
																									"data-bs-toggle": "modal",
																									"data-bs-target": "#emailNewTemplate"
																								} : {})}
																								onClick={(e) => {
																									if (selectedCustomers.length == 0) {
																										setSelectedCustomerslist([order.delinquentOrderId]);
																										SetSingleDeliquent(order)
																									}
																								}}
																							>
																								<em className="icon ni ni-mail"></em>
																							</button>
																						}
																					</div>
																				</td>
																				{showCheckboxes && (
																					<td className="tableMinWidth120">
																						<div className="custom-control custom-control-sm custom-checkbox">
																							<input
																								type="checkbox"
																								className="custom-control-input"
																								id={`customCheck${order.delinquentOrderId}`}
																								checked={selectedCustomers.includes(order.delinquentOrderId)}
																								onChange={(e) => {
																									handleCustomerSelect(e, order.delinquentOrderId);
																									// Log the selected customers array when checkbox is toggled
																									console.log("Selected Customers for Email:", selectedCustomers);
																									// Set the first checked order
																									if (e.target.checked && selectedCustomers.length === 0) {
																										SetSingleDeliquent(order);
																									}
																								}}
																							/>
																							<label className="custom-control-label" htmlFor={`customCheck${order.delinquentOrderId}`}></label>
																						</div>
																					</td>
																				)}
																			</>
																		)}
																	</tr>
																))
														) : (
															<tr>
																<td colSpan={profile?.name === "Admin" ? (showCheckboxes ? 12 : 11) : 8} className="text-center py-4">
																	{debouncedSearchTerm
																		? `No results found for "${debouncedSearchTerm}"`
																		: 'No delinquent orders found'}
																</td>
															</tr>
														)}
													</tbody>
												</table>
											</div>

											{count > 0 && (
												<div className="nk-block-between-md g-3 mt-3">
													<div className="g">
														<div className="pagination d-flex gap-2 align-items-center">
															<button
																className={`btn btn-sm ${currentPage === 1 ? 'btn-disabled' : 'btn-primary'}`}
																onClick={() => handlePageChange(currentPage - 1)}
																disabled={currentPage === 1 || apiLoading}
															>
																Previous
															</button>
															{renderPaginationButtons()}
															<button
																className={`btn btn-sm ${currentPage === totalPages ? 'btn-disabled' : 'btn-primary'}`}
																onClick={() => handlePageChange(currentPage + 1)}
																disabled={currentPage === totalPages || apiLoading}
															>
																Next
															</button>
														</div>
													</div>

													<div className="g">
														<div className="pagination-goto d-flex align-items-center gap-3">
															<div>Showing</div>
															<div>
																<select
																	className="form-select form-select-sm"
																	value={itemsPerPage}
																	onChange={handleItemsPerPageChange}
																	disabled={apiLoading}
																>
																	{[10, 20, 50, 100].map(size => (
																		<option key={size} value={size}>{size}</option>
																	))}
																</select>
															</div>
															<div>of {count} items</div>
														</div>
													</div>
												</div>
											)}
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="modal fade" tabindex="-1" id="delinquentModal">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Enter Ticket Number</h5>
							<a href="#" class="close" data-bs-dismiss="modal" aria-label="Close"><em class="icon ni ni-cross-c"></em></a>
						</div>
						<div class="modal-body inputCardBox">
							<div class="row">
								<div class="col-md-12 mb-3">
									<label>#Num</label>
									<input type="text" class="" placeholder="Ticket number" />
								</div>

								<div class="col-md-12 mb-3">
									<div className="table-responsive">
										<table class="table table-striped">
											<thead>
												<tr>
													<th scope="col">Ticket</th>
													<th scope="col">Event Date</th>
													<th scope="col">Event Date</th>
													<th scope="col">Customer Name</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<th scope="row">#6512</th>
													<td>Jan 18, 2025</td>
													<td>Dec 20, 2024</td>
													<td>Nicole Branson</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-md-4 mb-3">
									<button type="submit" class="addBtnCustomer">Confirm</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>



			<div className="modal fade" tabIndex="-1" id="addDelinquentModal">
				<div className="modal-dialog modal-lg" role="document">
					<div className="modal-content" style={{ width: "100%" }}>
						<div className="modal-header">
							<h5 className="modal-title">Add Delinquent Orders</h5>
							<a href="#" className="close" data-bs-dismiss="modal" aria-label="Close" ref={modalRef} onClick={() => {
								reset(); // Reset all form fields
								setTickets([]); // Clear tickets state
								setorderInfo(null)
							}}>
								<em className="icon ni ni-cross-c"></em>
							</a>
						</div>
						<div className="modal-body inputCardBox" >
							<form onSubmit={handleSubmit(onSubmit)}>
								<div className="row" style={{ minHeight: "250px" }}>
									<div className="col-md-6 mb-3">
										<label>Search & Select Account Name</label>
										<div className='searchdeliq'>
											<Controller
												name="customerName"
												control={control}
												rules={{ required: "Customer name is required" }}
												render={({ field, fieldState }) => (
													<>
														<Select
															{...field}
															isClearable  // Add this prop
															className={`basic-single ${fieldState.error ? 'is-invalid' : ''}`}
															classNamePrefix="select"
															// menuIsOpen={true}
															options={customer.map(data => ({
																value: data.id,
																label: `${data.account} ${data.companyName} `
															}))}
															placeholder="Select a customer"
															onChange={(selectedOption) => {
																field.onChange(selectedOption?.value || ""); // Update form value
																const selectedCustomer = customer.find(c => c.id === selectedOption?.value);
																setValue("account", selectedCustomer?.account || "");
																setValue("ticket", "");
																setTickets([]);
															}}
															value={customer.find(c => c.id === field.value) ?
																{
																	value: field.value,
																	label: customer.find(c => c.id === field.value)?.companyName
																} : null
															}
														/>
														{fieldState.error && (
															<div className="invalid-feedback">{fieldState.error.message}</div>
														)}
													</>
												)}
											/>
										</div>

									</div>

									<div className="col-md-6 mb-3">
										<label>Search Ticket</label>
										<div className='searchdeliq'>
											<Controller
												name="ticket"
												control={control}
												rules={{ required: "Ticket is required" }}
												render={({ field, fieldState }) => (
													<>
														<Select
															{...field}
															isClearable
															isLoading={loadingTickets} // 🔥 This shows the spinner
															className={`basic-single ${fieldState.error ? 'is-invalid' : ''}`}
															classNamePrefix="select"
															options={tickets.map(data => ({
																value: data?.ticket,
																label: data?.ticket
															}))}
															placeholder="Select a ticket"
															onChange={(selectedOption) => {
																field.onChange(selectedOption?.value || "");
																if (!selectedOption) {
																	setorderInfo(null);
																}
															}}
															value={tickets.find(t => t.ticket === field.value) ?
																{
																	value: field.value,
																	label: field.value
																} : null
															}
														/>

														{fieldState.error && (
															<div className="invalid-feedback">{fieldState.error.message}</div>
														)}
													</>
												)}
											/>
										</div>
									</div>
									{/* Rest of your modal content remains the same */}
									{
										orderInfo && <div className="col-md-12 mb-3">
											<div className="table-responsive">
												<table className="table table-striped">
													<thead>
														<tr className="modalAddTable">
															<th scope="col">Customer Name</th>
															<th scope="col">Event Date</th>
															<th scope="col">Order Type</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<th scope="row">{orderInfo?.first_name} {orderInfo?.last_name}</th>
															<td>{orderInfo?.order_type == "Single Order" ? moment(orderInfo?.event_date).format("MMM D, YYYY") : moment(orderInfo?.wedding?.wedding_date).format("MMM D, YYYY")}</td>
															<td>{orderInfo?.wedding_id ? "Wedding order" : "Single order"}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									}
								</div>

								<div className="row mt-3">
									<div className="col-md-12 mb-3">
										<button type="submit" className="addBtnCustomer" style={isSubmitting ? { pointerEvents: "none" } : {}}> {isSubmitting ? (
											<>
												<span class="spinner"></span> Submit
											</>
										) : (
											"Submit"
										)}</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>





			<EmailEditor data={SingleDeliquent} state={mergedIds} onEmailSent={getDelinquent} />
		</Container >
	)
}

export default Delinquent;
